export enum DateFormat {
  Date = 'yyyy-MM-dd',
  DateTime = 'yyyy-MM-dd, HH:mm:ss',
  DateMonth = 'yyyy-MM'
}
